import { Expose } from 'class-transformer';

export class HeaderProps {
  @Expose()
  text!: string;

  @Expose()
  size!: number;
}
